import React, { useMemo, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Stack, mergeStyles } from '@fluentui/react';
import { ChoiceGroup } from '@fluentui/react/lib/ChoiceGroup';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton } from '../../components';
import { CAMPAIGN_SELECTION_MODES } from './constants';

const descriptionStyles = mergeStyles({
  marginBottom: 16,
});

const choiceGroupStyles = mergeStyles({
  paddingLeft: 8,
});

const footerStyles = mergeStyles({
  marginTop: 32,
});

const nextButtonStyles = mergeStyles({
  marginRight: 8,
});

const fieldStyles = {
  field: {
    padding: 0,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 19,
  },
};

export const CampaignSelectionMode = ({
  campaignSelectionMode, setCampaignSelectionMode, goToSpecificCampaignSelection, applyChangesToAllCampaigns, onClose,
}) => {
  const i18n = useContext(I18nContext);

  const options = useMemo(() => [
    {
      key: CAMPAIGN_SELECTION_MODES.ALL,
      text: i18n.getString(_TL_('Apply to all campaigns')),
      styles: fieldStyles,
    },
    {
      key: CAMPAIGN_SELECTION_MODES.SPECIFIC,
      text: i18n.getString(_TL_('Apply to a specific campaign')),
      styles: fieldStyles,
    },
  ], [i18n]);

  const onCampaignSelectionModeChange = useCallback((ev, option) => {
    setCampaignSelectionMode(option.key);
  }, [setCampaignSelectionMode]);

  const onNext = useCallback(() => {
    if (campaignSelectionMode === CAMPAIGN_SELECTION_MODES.ALL) {
      applyChangesToAllCampaigns();
    } else if (campaignSelectionMode === CAMPAIGN_SELECTION_MODES.SPECIFIC) {
      goToSpecificCampaignSelection();
    }
  }, [campaignSelectionMode, applyChangesToAllCampaigns, goToSpecificCampaignSelection]);

  return (
    <div className="autobidding-campaign-selection-mode">
      <div className={descriptionStyles}>{i18n.getString(_TL_('You can choose to set automated bidding for a specific campaign or all campaigns.'))}</div>
      <div className={choiceGroupStyles}>
        <ChoiceGroup defaultSelectedKey={campaignSelectionMode} options={options} onChange={onCampaignSelectionModeChange} />
      </div>
      <Stack horizontal horizontalAlign="end" className={footerStyles}>
        <PrimaryButton text={i18n.getString(_TL_('Continue'))} onClick={onNext} className={classNames(nextButtonStyles, 'next-button')} />
        <DefaultButton text={i18n.getString(_TL_('Close'))} onClick={onClose} className="close-button" />
      </Stack>
    </div>
  );
};

CampaignSelectionMode.propTypes = {
  campaignSelectionMode: PropTypes.string.isRequired,
  applyChangesToAllCampaigns: PropTypes.func.isRequired,
  goToSpecificCampaignSelection: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setCampaignSelectionMode: PropTypes.func.isRequired,
};
